import "./button.css";

export default function Button({
  children = "View Project",
  href = "#",
  target = "_self",
  onClick,
}) {
  const isExternalTab = target === "_blank";

  return (
    <a
      href={href}
      target={target}
      rel={isExternalTab ? "noreferrer" : undefined}
      className="project-button"
      onClick={onClick}
    >
      <span>{children}</span>

      <span className="project-button-icon">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M9 6L15 12L9 18"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </a>
  );
}